export const TRIAL_PAGES_V4C = 'v4c';
